import { useLanguage } from '@/lib/i18n';
import { useQueryFilter } from '@/stores/useQueryFilterStore';
import { SortOption } from '@/types';
import { ArrowUpDown } from 'lucide-react';

export function SortSelect() {
    const { t } = useLanguage();

    const sortOptions = [
        { value: '-created_at', label: t('sort.created_at') },
        { value: 'brewery', label: t('sort.breweryAZ') },
        { value: '-brewery', label: t('sort.breweryZA') },
        { value: 'name', label: t('sort.titleAZ') },
        { value: '-name', label: t('sort.titleZA') },
        { value: 'untappd', label: t('sort.untappdAZ') },
        { value: '-untappd', label: t('sort.untappdZA') },
        { value: 'style', label: t('sort.styleAZ') },
        { value: '-style', label: t('sort.styleZA') },
        { value: 'price', label: t('sort.priceAZ') },
        { value: '-price', label: t('sort.priceZA') },
        { value: 'packaging_type', label: t('sort.tareAZ') },
        { value: '-packaging_type', label: t('sort.tareZA') },
        { value: 'volume', label: t('sort.volumeAZ') },
        { value: '-volume', label: t('sort.volumeZA') },
    ];

    const { sort, handleSort } = useQueryFilter();

    return (
        <div className="relative mt-3 w-full sm:w-[50%] md:mt-0">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-zinc-500">
                <ArrowUpDown className="h-4 w-4" />
            </div>
            <select
                value={sort}
                onChange={(e) => handleSort(e.target.value as SortOption)}
                className="block h-10 w-full cursor-pointer appearance-none rounded-lg border border-zinc-800 bg-zinc-900 px-10 text-sm text-brand-mist transition-all hover:bg-zinc-800 focus:border-brand-gold focus:outline-none focus:ring-brand-gold"
            >
                {sortOptions.map((o) => (
                    <option key={o.value} value={o.value}>
                        {o.label}
                    </option>
                ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                <svg
                    className="h-4 w-4 text-zinc-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </div>
        </div>
    );
}
